import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface AccordionSectionProps {
  title: string;
  children: ReactNode;
}

const AccordionSection = ({ title, children }: AccordionSectionProps) => (
  <AccordionItem
    borderBottom='1px'
    borderColor='border.light'
    borderTop={0}
  >
    <AccordionButton
      fontWeight='semibold'
      justifyContent='space-between'
      px='0'
      py='md'
      textAlign='left'
    >
      {title}
      <AccordionIcon />
    </AccordionButton>
    <AccordionPanel px={0}>{children}</AccordionPanel>
  </AccordionItem>
);

export default AccordionSection;
